import discordimg from './images/discord.png';
import twitterimg from './images/twitter2.png';
// import ihammer from './images/i-hammer-brown.png';
import './css/Nav.css';

function Nav() {
  	return (
        <div>
            <div className="nav-container">
                <div className="topnav kfont">
                    <a className="mainnav storynav" href="https://tota.gg/#story">STORY</a>
                    <a className="mainnav rmapnav" href="https://tota.gg/#roadmap">ROADMAP</a>
                    <a className="mainnav teamnav" href="https://tota.gg/#team">TEAM</a>
                    <a className="mainnav faqnav" href="https://tota.gg/#faq">FAQ</a>
                    <a className="mainnav" href="https://discord.com/invite/tota" target="_blank" rel="noreferrer">DISCORD</a>
                    <a className="mainnav" href="https://twitter.com/TOTACollection" target="_blank" rel="noreferrer">TWITTER</a>
                    <span id="topnavr">
                        <a href="https://discord.com/invite/tota" target="_blank" rel="noreferrer"><img src={discordimg} height="39" width="34" alt="discord" /></a>
                        <a href="https://twitter.com/TOTACollection" target="_blank" rel="noreferrer"><img src={twitterimg} width="36" height="36" alt="twitter" /></a>
                    </span>
{/*                    <span id="smob">
                        <a href="#" id="toggle-anchor">
                            <div id="menu-icon">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </a>
                        <ul id="menu" className="mobile-menu-list kfont" aria-label="mobile menu"> 
                            <li className="mobile-list-item"><img src={ihammer} width="50px" height="50px" alt="hammer" /></li> 
                            <li className="mobile-list-item"><a className="mobile-link-item storynav" href="#story">Story</a></li> 
                            <li className="mobile-list-item"><a className="mobile-link-item rmapnav" href="#roadmap">Roadmap</a></li> 
                            <li className="mobile-list-item"><a className="mobile-link-item teamnav" href="#team">Team</a></li> 
                            <li className="mobile-list-item"><a className="mobile-link-item faqnav" href="#faq">FAQ</a></li> 
                            <li className="mobile-list-item"><a className="mobile-link-item" href="https://discord.com/invite/tota" target="_blank" rel="noreferrer">OUR DISCORD</a></li> 
                            <li className="mobile-list-item"><a className="mobile-link-item" href="https://twitter.com/TOTACollection" target="_blank" rel="noreferrer">OUR TWITTER</a></li>
                        </ul>
                    </span>*/}
                </div>
            </div>
        </div>
  	);
}
export default Nav;


